import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[ErrorBoundary] ${this.props.name || 'Component'} crashed:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px 24px',
          color: 'rgba(255,255,255,0.6)',
          textAlign: 'center',
          minHeight: 120,
        }}>
          <div style={{ fontSize: 28, marginBottom: 8 }}>⚠</div>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4, color: 'rgba(255,255,255,0.8)' }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 12, marginBottom: 12, opacity: 0.6 }}>
            {this.props.name ? `The ${this.props.name} section encountered an error.` : 'This section encountered an error.'}
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.12)',
              borderRadius: 8,
              color: 'rgba(255,255,255,0.7)',
              padding: '8px 20px',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
